/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_DecouplingInputs */

const en_ui_more_stats_decoupling = /** @type {(inputs: Ui_More_Stats_DecouplingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decoupling`)
};

const de_ui_more_stats_decoupling = /** @type {(inputs: Ui_More_Stats_DecouplingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drift`)
};

/**
* | output |
* | --- |
* | "Decoupling" |
*
* @param {Ui_More_Stats_DecouplingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_decoupling = /** @type {((inputs?: Ui_More_Stats_DecouplingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_DecouplingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_decoupling(inputs)
	return de_ui_more_stats_decoupling(inputs)
});